import {Translate} from "components/common/Translate/Translate";
import {ContentParent} from "components/modules/Content/ContentParent";
import {ContentItem} from "components/modules/Content/ContentItem/ContentItem";
import {Award, FileStack, Gift, Lightbulb, PencilRuler, ShieldCheck} from "lucide-react";

export const JpgResizerFeaturesContent = () => {
    return (
        <ContentParent>
            <ContentItem
                title={<Translate keyName="content-quality-title" />}
                description={<Translate keyName="content-quality-sub-title" />}
                icon={<Award strokeWidth={1.5} width={30} height={30}/>}
            />
            <ContentItem
                title={<Translate keyName="content-user-friendly-title" />}
                description={<Translate keyName="content-user-friendly-sub-title" />}
                icon={<Lightbulb strokeWidth={1.5} width={30} height={30}/>}
            />
            <ContentItem
                title={<Translate keyName="content-quick-easy-title" />}
                description={<Translate keyName="content-quick-easy-sub-title" />}
                icon={<PencilRuler strokeWidth={1.5} width={30} height={30}/>}
            />

            <ContentItem
                title={<Translate keyName="content-Works-Anywhere-title" />}
                description={<Translate keyName="content-Works-Anywhere-sub-title" />}
                icon={<FileStack strokeWidth={1.5} width={30} height={30}/>}
            />

            <ContentItem
                title={<Translate keyName="content-Secure-title" />}
                description={<Translate keyName="content-Secure-sub-title" />}
                icon={<Gift strokeWidth={1.5} width={30} height={30}/>}
            />
            <ContentItem
                title={<Translate keyName="content-Free-title" />}
                description={<Translate keyName="content-Free-sub-title" />}
                icon={<ShieldCheck strokeWidth={1.5} width={30} height={30}/>}
            />
        </ContentParent>
    );
};
